import React from 'react'

const WorkPage = () => {
  return (
    <div>WorkPage</div>
  )
}

export default WorkPage